import { ModuleFE_NoteTemplate } from './ModuleFE_NoteTemplate.js';
export const ModulePackFE_NoteTemplateDB = [ModuleFE_NoteTemplate];
//# sourceMappingURL=module-pack.js.map